import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import Chat from './Chat'
import { CONTENT_TYPES } from './constants'

/**
 * Specialized component for stand alone Freddie Mac guideline chat url
 */
function FannieMaeChat({ fromLanding = true }) {
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch({ type: 'CHANGE_PDF', data: CONTENT_TYPES.FANNIE_MAE })
        dispatch({ type: 'SHOW_PDF', data: false }) 
    }, [dispatch])

    return <Chat fromLanding={fromLanding} />
}

export default FannieMaeChat
